import {
  cloneDeep,
} from 'lodash';

import {
  importJsonData,
  initGetData,
} from '@/payloadTemplates';

const {
  templates,
  prefill = {},
} = importJsonData(
  require.context('./', false, /\.json$/),
  // require.context('./prefill/', false, /\.json$/),
);

const getData = initGetData(templates, prefill);

export const PET = getData(['pet']);
export const COVER = getData('cover');
export const PROPOSER = getData('proposer');

export const QUOTE = {
  cover: cloneDeep(COVER),
  proposer: cloneDeep(PROPOSER),
};

export const getQuotePayload = config => {
  const payload = cloneDeep(QUOTE);
  payload.proposer.userKeepSignIn = process.env.NODE_ENV === 'production' ? config.partnerSignin : !!process.env.VUE_APP_PARTNER_SIGNIN;

  return payload;
};
